import React, { useState, useCallback } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
} from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import { listBroadcastTemplates } from "../../services/messaging.api";

const BroadcastTemplatePickerIcon = ({ disabled, onSelect }) => {
  const [anchor, setAnchor] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);

  const handleOpen = useCallback(async (e) => {
    setAnchor(e.currentTarget);
    if (!fetched) {
      setLoading(true);
      try {
        const { data } = await listBroadcastTemplates({ pageNumber: 1, pageSize: 50, activeOnly: true });
        setTemplates(data.records || []);
        setFetched(true);
      } catch {
        setTemplates([]);
      } finally {
        setLoading(false);
      }
    }
  }, [fetched]);

  return (
    <>
      <Tooltip title="Plantillas de Difusión">
        <span>
          <IconButton
            size="small"
            disabled={disabled}
            onClick={handleOpen}
            aria-label="Plantillas de Difusión"
          >
            <DescriptionIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{ style: { maxHeight: 400, minWidth: 260 } }}
      >
        {loading && (
          <MenuItem disabled>
            <Box display="flex" alignItems="center" style={{ gap: 8 }}>
              <CircularProgress size={14} />
              <Typography variant="body2">Cargando plantillas…</Typography>
            </Box>
          </MenuItem>
        )}
        {!loading && templates.length === 0 && (
          <MenuItem disabled>
            <Typography variant="body2">Sin plantillas activas</Typography>
          </MenuItem>
        )}
        {!loading &&
          templates.map((t) => (
            <MenuItem
              key={t.id}
              dense
              onClick={() => {
                onSelect(t.body);
                setAnchor(null);
              }}
            >
              <Box style={{ maxWidth: 300 }}>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                  {t.name}
                </Typography>
                <Typography
                  variant="caption"
                  style={{
                    color: "#888",
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {t.body.length > 70 ? t.body.substring(0, 70) + "…" : t.body}
                </Typography>
              </Box>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default BroadcastTemplatePickerIcon;
